import { Injectable, OnInit, Injector } from '@angular/core';
import {ParserService } from '../ws/ws.service';
import {environment} from '../../../../environments/environment';
import {IChatParser} from './chat-parser';
import {IChatManager} from './chat-manager';
import {WsService2} from '../ws/ws.service';
@Injectable()
export class ChatParserService extends ParserService implements IChatParser{
    constructor(ws: WsService2){
       super(ws);
    }
    setChatManager(r:IChatManager){
        this.chatManager = r;
    }
   chatManager: IChatManager
   parseMessage(m){
       switch (m.cmd){
           case "chat": this.onMessage(m); break;
       }
   }
   onMessage(m){
       this.chatManager.onMessage(m.from, m.name, m.message, m.me, m.isPrivate);
   }
   sendMessage(message, reciever){
       this.send("chat", {message:message, reciever: reciever});
   }
}



// WEBPACK FOOTER //
// /app/src/app/wb/services/chat/chat-parser.service.ts